import { render, staticRenderFns } from "./ScreeningItem.vue?vue&type=template&id=165d9a58&scoped=true&"
import script from "./ScreeningItem.vue?vue&type=script&lang=js&"
export * from "./ScreeningItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningItem.vue?vue&type=style&index=0&id=165d9a58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d9a58",
  null
  
)

export default component.exports